var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "step-navigation" }, [
    _vm.error ? _c("p", [_vm._v(_vm._s(_vm.error))]) : _vm._e(),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "step-navigation__button",
        attrs: { type: "submit" },
        on: { click: _vm.toggleNextStep },
      },
      [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }